// Libs
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

// Utils
import {
  getOrderQty,
  getTotalOrderedQty,
} from '../../../../../pages/OrderHistory/utils/getQuantity';

const OrderCardQtyColumns = ({
  order,
  productsObj,
  gridPropValues,
  classes,
  cx,
}) => (
  <>
    <Grid
      item
      flexBasis={gridPropValues({
        lgSize: 2,
        unit: '%',
      })}
      order={gridPropValues({ lgSize: 2 })}>
      <Box display="flex" flexDirection="column" data-testid="order-qty">
        <Typography className={classes.headerText}>Order Qty:</Typography>
        <Typography className={classes.text}>{getOrderQty(order)}</Typography>
      </Box>
    </Grid>
    <Grid
      item
      flexBasis={gridPropValues({
        lgSize: 2,
        unit: '%',
      })}
      order={gridPropValues({
        lgSize: 3,
      })}>
      <Box display="flex" flexDirection="column" data-testid="total-ordered">
        <Typography className={cx(classes.headerText, classes.totalItems)}>
          Total Ordered:
        </Typography>
        <Typography className={cx(classes.text, classes.totalItems)}>
          {getTotalOrderedQty(order, productsObj)}
        </Typography>
      </Box>
    </Grid>
  </>
);

export default OrderCardQtyColumns;
